var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCropActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0057A0",
    fillRule: "nonzero",
    d: "M4.125 0c.225 0 .412.162.45.376l.008.082v3.208h10.542c.225 0 .412.163.45.377l.008.082a.458.458 0 0 1-.376.45l-.082.008H4.583v12.185l1.968-1.967a.458.458 0 0 1 .576-.059l.072.06a.458.458 0 0 1 .059.575l-.059.072-1.968 1.967h12.185V6.876c0-.226.163-.413.377-.452l.082-.007c.225 0 .412.162.45.376l.008.082v14.667a.458.458 0 0 1-.909.082l-.007-.082-.001-3.21-12.374.001a1.37 1.37 0 0 1-.962-.393l-.02-.02a1.372 1.372 0 0 1-.387-.83l-.006-.132V.458c0-.253.205-.458.458-.458zm17.417 17.417a.458.458 0 0 1 .082.909l-.082.007h-1.834a.458.458 0 0 1-.082-.909l.082-.007h1.834zm-10.676-6.283a.458.458 0 0 1 .058.577l-.058.072-2.292 2.291a.458.458 0 0 1-.707-.576l.059-.072 2.292-2.292a.458.458 0 0 1 .648 0zm3.666-3.667a.458.458 0 0 1 .06.577l-.06.072-2.291 2.291a.458.458 0 0 1-.707-.576l.059-.072 2.291-2.292a.458.458 0 0 1 .648 0zM18.2 3.801a.458.458 0 0 1 .059.576l-.059.072-2.292 2.292a.458.458 0 0 1-.706-.577l.058-.072 2.292-2.291a.458.458 0 0 1 .648 0zM2.292 3.667a.458.458 0 0 1 .082.909l-.082.007H.458a.458.458 0 0 1-.082-.909l.082-.007h1.834zM21.218.134a.458.458 0 0 1 .648.648l-2.292 2.292a.458.458 0 0 1-.648-.648z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropActive);
export default __webpack_public_path__ + "static/media/crop-active.89c9efead2ce293366e9b50a6813b474.svg";
export { ForwardRef as ReactComponent };